import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSnackBar} from '@angular/material';
import {CustomerService} from '../../services/customer.service';
import {SharedService} from '../../services/shared.service';
import {SNACK_CONFIG} from '../../global';

@Component({
  selector: 'app-picture-dialog',
  templateUrl: './picture-dialog.component.html',
  styleUrls: ['./picture-dialog.component.scss']
})
export class PictureDialogComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showLoader: boolean;

  constructor(public dialogRef: MatDialogRef<PictureDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private shared: SharedService,
              private customerService: CustomerService,
              private snackBar: MatSnackBar) {

  }

  ngOnInit() {
  }

  fileChanged(event) {
    this.imageChangedEvent = event;
  }

  imageCropped(image: string) {
    this.croppedImage = image;
  }

  saveImage() {
    this.showLoader = true;
    this.customerService.uploadProfilePicture(this.croppedImage)
      .then(url => {
        return this.customerService.updateCustomerProfile({pictureURL: url});
      })
      .then(res => {
        this.showLoader = false;
        this.customerService.getCurrentCustomer(true)
          .then(() => {
            this.snackBar.open('Picture updated', null, SNACK_CONFIG);
            this.dialogRef.close();
          });
      })
      .catch(err => {
        this.showLoader = false;
        this.dialogRef.close();
        this.shared.openErrorDialog({title: 'Error', body: err.errorMessage || 'Unexpected error'});
      });
  }

  loadImageFailed() {
    this.dialogRef.close();
    this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error'});
  }

}
